import { Component, computed, input } from "@angular/core";

import { FooterModel } from "./model/footer-model";
import { TranslatePipe } from "@ngx-translate/core";
import { SocialUrlModel } from "./model/social-url-model";

@Component({
  selector: "portal-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [TranslatePipe],
})
export class FooterComponent {
  readonly model = input<FooterModel>();
  readonly providedSocialsUrls = computed(() => {
    if (this.model()) {
      const existingSocials: SocialUrlModel[] = [];
      if (this.model()?.facebookUrl && this.model()?.facebookUrl?.trim() !== "") {
        existingSocials.push({ icon: "fab fa-facebook-square", url: this.model()!.facebookUrl!.trim() });
      }
      if (this.model()?.youtubeUrl && this.model()?.youtubeUrl?.trim() !== "") {
        existingSocials.push({ icon: "fab fa-youtube-square", url: this.model()!.youtubeUrl!.trim() });
      }
      if (this.model()?.twitterUrl && this.model()?.twitterUrl?.trim() !== "") {
        existingSocials.push({ icon: "fab fa-twitter-square", url: this.model()!.twitterUrl!.trim() });
      }
      if (this.model()?.instagramUrl && this.model()?.instagramUrl?.trim() !== "") {
        existingSocials.push({ icon: "fab fa-instagram-square", url: this.model()!.instagramUrl!.trim() });
      }
      return existingSocials;
    } else {
      return [];
    }
  });
  readonly copyrightText = this.#getCopyrightYear();

  #getCopyrightYear(): string {
    const copyrightText = "© g.a.s.t. ";
    const currentDate: Date = new Date();

    return copyrightText + currentDate.getFullYear();
  }
}
